"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("./Input"));

var _Link = _interopRequireDefault(require("../Typography/Link"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * InputPassword component
 */
var InputPassword =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputPassword, _React$Component);

  function InputPassword(props) {
    var _this;

    _classCallCheck(this, InputPassword);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputPassword).call(this, props));

    _this.handleOnLinkClick = function () {
      var showPassword = !_this.state.showPassword;

      _this.setState({
        showPassword: showPassword
      });

      if ((0, _isFunction2.default)(_this.props.onVisibilityChange)) {
        _this.props.onVisibilityChange(showPassword);
      }
    };

    _this.state = {
      showPassword: props.showPassword
    };
    return _this;
  }

  _createClass(InputPassword, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.showPassword !== this.state.showPassword) {
        this.setState({
          showPassword: nextProps.showPassword
        });
      }
    }
    /**
     * Show/Hide click handler
     */

  }, {
    key: "render",
    value: function render() {
      var showPassword = this.state.showPassword; // Extract out showPassword and onVisibilityChange to avoid unknow prop
      // warning from Ant Input

      /* eslint-disable no-unused-vars */

      var _this$props = this.props,
          showSuffix = _this$props.showSuffix,
          hideSuffix = _this$props.hideSuffix,
          className = _this$props.className,
          showHideLinkProps = _this$props.showHideLinkProps,
          onVisibilityChange = _this$props.onVisibilityChange,
          showPasswordProp = _this$props.showPassword,
          props = _objectWithoutProperties(_this$props, ["showSuffix", "hideSuffix", "className", "showHideLinkProps", "onVisibilityChange", "showPassword"]);
      /* eslint-enable no-unused-vars */


      return _react.default.createElement(_Input.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-input-password"))
      }, props, {
        type: showPassword ? 'text' : 'password',
        suffix: _react.default.createElement(_Link.default, _extends({}, showHideLinkProps, {
          onClick: this.handleOnLinkClick,
          className: "suffix-label",
          disabled: this.props.disabled
        }), showPassword ? hideSuffix : showSuffix)
      }));
    }
  }]);

  return InputPassword;
}(_react.default.Component);

exports.default = InputPassword;
InputPassword.defaultProps = {
  showSuffix: _I18nManager.default.t('InputPassword', 'show'),
  hideSuffix: _I18nManager.default.t('InputPassword', 'hide'),
  showPassword: false
};
InputPassword.propTypes = {
  /**
   * Whether or not this input is disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Suffix label to show when password is hidden.
   */
  showSuffix: _propTypes.default.node,

  /**
   * Suffix label to show when password is visible.
   */
  hideSuffix: _propTypes.default.node,

  /**
   * Option to show password.
   */
  showPassword: _propTypes.default.bool,

  /**
   * onVisibilityChange function used to provide current state
   * @param {boolean} visibleInfo - Current state of showPassword.
   */
  onVisibilityChange: _propTypes.default.func,

  /**
   * className is used to add extra class for adding new style to override
   * default
   */
  className: _propTypes.default.string,

  /**
   * Props to pass to show/hide link
   */
  showHideLinkProps: _propTypes.default.object
};